jQuery('.faq-strip').on('click touch', function() {
  jQuery('.faq-strip').not(this).removeClass('open');
  jQuery(this).toggleClass('open'); 
});